var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FieldBasics } from '@/components/mambas';
import { AjaxBasics, EnumAPI } from '@mamba/clients';
import lodash from 'lodash';
import { Component, Emit, Inject, Mixins, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Mixins(FieldBasics) {
    constructor() {
        super(...arguments);
        // 表单类型
        // @Inject({ default: "" }) readonly formType;
        this.previewUrl = '';
        this.previewVisible = false;
        this.fileList = [];
    }
    get isShowUpload() {
        return !this.isReadonly || (this.isReadonly && this.value);
    }
    get isReadonly() {
        return this.disabled || this._readonly;
    }
    get headers() {
        return {
            token: this.$Store.System.AccessToken,
        };
    }
    get max() {
        return lodash.get(this._fieldProps, 'max', 1);
    }
    get value() {
        return lodash.get(this.formState, this._name);
    }
    set value(value) {
        lodash.set(this.formState, this._name, value);
    }
    get isPlusBottun() {
        return (!(this.disabled || this._readonly) && this.fileList.length < this.max);
    }
    get message() {
        return lodash.get(this._fieldProps, 'message', false);
    }
    get accept() {
        return lodash.get(this._fieldProps, 'accept', 'image/*');
    }
    get uploadText() {
        return lodash.get(this._fieldProps, 'uploadText', 'Upload');
    }
    get needUrl() {
        return lodash.get(this._fieldProps, 'needUrl', undefined);
    }
    get icon() {
        return this._fieldProps.icon || 'plus';
    }
    get novalidity() {
        return this._fieldProps.novalidity || false;
    }
    get isAvatar() {
        return lodash.get(this._fieldProps, 'avatar', false);
    }
    onChange(event) {
        if (event.file.status === 'removed') {
            this.value = undefined;
            lodash.set(this.formState, this._name, undefined);
            if (this.needUrl) {
                lodash.set(this.formState, this.needUrl, undefined);
            }
            this.fileList = [];
            return;
        }
        if (event.file.status === 'uploading') {
            this.spinning = true;
        }
        else {
            this.spinning = false;
            if (event.file.status === 'done') {
                if (!event.file.response.data) {
                    this.$message.error(event.file.response.msg);
                    this.fileList = [];
                }
                else {
                    // this.value = src;
                    // lodash.set(this.formState, this._name, src);
                }
            }
        }
    }
    // 预览
    handlePreview(file) {
        this.previewUrl = lodash.has(file, 'url')
            ? file.url
            : file?.response?.data.src;
        this.previewVisible = true;
    }
    customRequest() { }
    beforeUpload(file) {
        let FileExt = file.name.replace(/.+\./, '');
        if (this.accept != 'image/*' && !lodash.includes(this.accept, FileExt)) {
            return this.$message.warning(`请上传${this.accept
                .replace(/\./, '')
                .replace(/\./g, '/')
                .replace(/\,/g, '')}类型`);
        }
        return new Promise(async (resolve, reject) => {
            const maxSize = this._fieldProps.maxSize;
            if (maxSize && file.size > maxSize) {
                this.$message.warning(`上传的图片超过最大限制`);
                return reject(false);
            }
            try {
                const formData = new FormData();
                formData.append('file', file);
                let url = '';
                if (this.novalidity) {
                    url = await this.onUploadFile(formData);
                    this.value = url;
                    lodash.set(this.formState, this._name, url);
                }
                else {
                    // 获取 到 fileId
                    const fileInfo = await this.onGetFile(formData);
                    url = await this.getUrl(fileInfo.fileId);
                    this.value = fileInfo.fileId;
                    lodash.set(this.formState, this._name, fileInfo.fileId);
                }
                this.fileList = [
                    {
                        uid: '-1',
                        name: 'image.png',
                        status: 'done',
                        url: url,
                    },
                ];
                if (this.needUrl) {
                    lodash.set(this.formState, this.needUrl, url);
                }
            }
            catch {
                return Promise.reject(false);
            }
            return resolve(true);
        });
    }
    async onValueChange(val, old) {
        if (val && lodash.isEmpty(this.fileList)) {
            let url = val;
            if (!lodash.includes(val, 'http')) {
                url = await this.getUrl(val);
            }
            this.fileList = [
                {
                    uid: '-1',
                    name: 'image.png',
                    status: 'done',
                    url,
                },
            ];
        }
    }
    /**
     * @descriptions 获取文件 id
     * @params entity
     */
    async onGetFile(entity) {
        // 有时效性
        try {
            const authorizeCode = await this.onAuthorizeCode();
            return await AjaxBasics.request(lodash.assign({}, EnumAPI.companyCert_file_upload, {
                url: `${EnumAPI.companyCert_file_upload.url}/${authorizeCode}`,
                body: entity,
            }));
        }
        catch { }
    }
    async getUrl(fileId) {
        return await AjaxBasics.request({
            ...EnumAPI.companyCert_file,
            body: { fileId },
        });
    }
    // 无时效性
    async onUploadFile(entity) {
        try {
            const authorizeCode = await this.getFileCode();
            const api = this.AppConfig.release
                ? EnumAPI.companyCert_file_upload_share_prod
                : EnumAPI.companyCert_file_upload_share;
            return await AjaxBasics.request(lodash.assign({}, api, {
                url: `${api.url}/${authorizeCode}`,
                body: entity,
            }));
        }
        catch { }
    }
    /**
     * @descriptions 获取文件中心授权码，有时效性
     * @params
     */
    async onAuthorizeCode() {
        return await AjaxBasics.request(EnumAPI.companyCert_getAuthorizeCode);
    }
    /**
     * @descriptions 获取文件中心授权码，无时效性
     * @params
     */
    async getFileCode() {
        return await AjaxBasics.request(EnumAPI.idass_get_file_code);
    }
};
__decorate([
    Inject()
], default_1.prototype, "formState", void 0);
__decorate([
    Inject()
], default_1.prototype, "PageEntity", void 0);
__decorate([
    Emit('change')
], default_1.prototype, "onChange", null);
__decorate([
    Watch('value')
], default_1.prototype, "onValueChange", null);
default_1 = __decorate([
    Component({ components: {} })
], default_1);
export default default_1;
// function getBase64(img: Blob, callback: (base64Url: string) => void) {
//   const reader = new FileReader();
//   reader.addEventListener('load', () => callback(reader.result as string));
//   reader.readAsDataURL(img);
// }
